import React from 'react';

import PropTypes from 'prop-types';

import TextButton from 'components/application/buttons/TextButton';
import ModalBox from 'components/application/ModalBox';

import { useCurrentActor } from 'components/contexts/CurrentActor';

import LoadingIcon from '-!svg-react-loader?name=LoadingIcon!icons/loading.svg';

export default function DuplicationInProgressModal({
  onClose,
  originalProject,
}) {
  const singularRAMSName =
    useCurrentActor().division.attributes.singularRAMSName || 'RAMS';

  return (
    <ModalBox
      isOpen={true}
      mode='letterbox'
      onClose={onClose}
      withFooter={false}
    >
      <>
        <h2 className='modalbox-header__title truncated-text-container tw-border-0 tw-border-b-1 tw-border-solid tw-border-grey-100 tw-p-6 tw-text-xl tw-font-semibold tw-text-grey-900'>
          Duplicate {originalProject.attributes.name}
        </h2>
        <div className='modalbox-body tw-flex tw-flex-col tw-items-center tw-py-6'>
          <span className='tw-apply-loading-spinner--blue-light tw-py-6'>
            <LoadingIcon height={48} width={48} />
          </span>
          <div className='tw-pb-4 tw-text-l tw-font-semibold tw-text-grey-900'>
            Creating {singularRAMSName}
          </div>
          <div className='tw-w-full tw-pb-6 tw-text-center'>
            This may take a few minutes.
          </div>
        </div>
        <div className='action-modal__footer tw-border-grey-100'>
          <TextButton color='blue' onClick={onClose} size='md'>
            Close
          </TextButton>
        </div>
      </>
    </ModalBox>
  );
}

DuplicationInProgressModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  originalProject: PropTypes.object.isRequired,
};
